import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: [],
};
export default createSlice({
  name: 'analyzer',
  initialState,
  selectors: {
    selectFilters: (state) => state.filters,
  },
  reducers: {
    setData: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
